import React, { useCallback, useRef } from "react";
import { Spinner } from "../../../useOss";
import SaasTooltip from "../SaasTooltip";
import { ApiKeyActionProps } from "./CreateApiKeyButton";

type DeleteApiKeyButtonProps = {
  isDisabled?: boolean;
} & ApiKeyActionProps;

export const DeleteApiKeyButton: React.FC<DeleteApiKeyButtonProps> = ({ status, onClick, isDisabled }) => {
  const buttonRef = useRef(null)
  const onButtonClick = useCallback((event: Pick<Event, "preventDefault">) => {
    event.preventDefault();
    if (onClick!== undefined && !isDisabled) { onClick(); }
  }, [onClick])
  return <>
    {status === "loading" ? 
      <Spinner isInline={true} /> :
      <a className="" href="" onClick={onButtonClick} ref={buttonRef}>
        <img src={`static/assets/dashboard/close-rounded${isDisabled ? "" : "-red"}.png`} alt="Delete ApiKey"/>
      </a>
    }
    {isDisabled && <SaasTooltip
      trigger="hover"
      elementRef={buttonRef}
      maxWidth="220px"
      css={{minWidth: "unset", minHeight: "unset", padding: "14px", fontSize: "14px", textAlign: "center"}}
    > 
      Deleting disabled. You need at least one API key
    </SaasTooltip>}
  </>
}